import BaseApi from 'nast-api'
import BaseRequestBuilder from 'nast-api/RequestBuilder'

/**
 *
 */
export default class NastApi extends BaseApi {
  /**
   * Creates an instance of NastApi.
   * @param {BaseRequestBuilder} requestBuilder - The request builder instance.
   * @param {Object} [config={}] - Optional configuration object.
   */
  constructor(requestBuilder, config = {}) {
    super(requestBuilder, config)
    this._setupInterceptors()
  }
  
  /**
   * Sets up request interceptors for the default instance to add authorization headers.
   * @private
   */
  _setupInterceptors() {
    if (!this._instances["default"]) {
      return
    }
    
    this._instances["default"].interceptors.request.use((config) => {
      const token = this.getAuthToken()
      
      if (token) {
        config.headers["Authorization"] = "Bearer " + token
      }
      return config
    });
  }

  /**
   * Retrieves the authentication token from localStorage.
   * @return {string|null} The authentication token if available, otherwise null.
   */
  getAuthToken() {
    try {
      const authData = localStorage.getItem('auth')
      if (authData) {
        const parsed = JSON.parse(authData)
        return parsed.token
      }
    } catch (error) {
      console.error('Error parsing auth data:', error)
    }
    
    return null
  }
}

/**
 *
 */
export class RequestBuilder extends BaseRequestBuilder {

}
